import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { findInVNode } from 'utils/vnode';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	checkHubTypePage() {
		const store = this.state.appState || {};
		const activePage = store.activePage || '';
		const pageData = store.appData?.pages?.[activePage] || {};
		const isCustomScroll = pageData.component === 'customScroll' || pageData.page === 'customScroll';
		const isHub = pageData.component === 'hub' || pageData.page === 'hub' || activePage === 'boltHubPage';
		return isHub || isCustomScroll;
	}

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const header = findInVNode(base, '[key="header"]');
		if (!header) return base;

		const isHubTypePage = this.checkHubTypePage();
		const hubActivePercentage = state?.appState?.hubActivePercentage;
		const headerForceSolidBackground = isHubTypePage && ((hubActivePercentage || 0) < 0.1);
		header.attributes = {
			...header.attributes,
			hubActivePercentage,
			solidBackground: headerForceSolidBackground || header.attributes.solidBackground,
			isHubTypePage
		};

		return base;
	}

}
